import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getProducts, setSelectedProduct } from '../../features/products/productSlice';
import '../selectProductModal/SelectProductModal.css';
import { setComplaintType, setTextForSearching, setSelectedRow, setProductsSuccess } from '../../features/products/productSlice';
import { setProduct } from '../../features/complaintPosition/ComplaintPositionSlice';

const SelectProductModal = ({ complaintType, selectedRow, clearText, setClearText, isEditMode,name,style }) => {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.products.products);
  const textForSearching = useSelector((state) => state.products.textForSearching);
  const [hideSearchingList, setHideSearchingList] = useState(false);
  const [selectedValue, setSelectedValue] = useState(selectedRow ? `${selectedRow.code} ${selectedRow.name}` : '');

  const handleSelectProduct = useCallback((product) => {
    dispatch(setSelectedProduct(product));
    dispatch(setSelectedRow(product));
    dispatch(setProduct(product));
    setSelectedValue(`${product.code} ${product.name}`);
    setHideSearchingList(true);
  }, [dispatch]);

  const handleInputChange = useCallback((e) => {
    const searchText = e.target.value;
    setSelectedValue(searchText); 
    dispatch(setTextForSearching(searchText));
    setHideSearchingList(false); 
    handleSearch(searchText);
  }, [dispatch]);

  // Handle search
  const handleSearch = useCallback((searchText) => {
    dispatch(setComplaintType(complaintType));
    dispatch(getProducts({ text: searchText, complaintType }));
  }, [dispatch, complaintType]);

  useEffect(() => {
    dispatch(getProducts({ text: '', complaintType }));
  }, [dispatch, complaintType]);

  useEffect(() => {
    if (clearText) {
      setSelectedValue('');
      dispatch(setSelectedProduct(null));
      dispatch(setSelectedRow(null));
      dispatch(setProduct(null));
      setHideSearchingList(false);
      setClearText(false);
    }
  }, [clearText, dispatch]);

  useEffect(() => {
    if (isEditMode) {
      setHideSearchingList(true);
    }
  }, [isEditMode]);

  return (
    <div>
      <label htmlFor='product'>
        <input
          autoComplete='off'
          type='text'
          id='product'
          className='input-field'
          value={selectedValue}
          onChange={handleInputChange}
          list='data'
          placeholder='Nazwa lub kod produktu, EAN'
          style={style}
          name={name}
        />
      </label>

      {textForSearching && !hideSearchingList && (
        <div className='product-searching-list' id='data'>
          {products.map((product) => (
            <div
              className={`product-searching-row ${selectedRow && selectedRow.id === product.id ? 'selected' : ''}`}
              key={product.id}
              onClick={() => handleSelectProduct(product)}
            >
              <p className='product-searching-row'>{product.code} {product.name}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectProductModal;